<script>
    import { t } from '$lib/translations';
	import Donate from "/src/components/Donate.svelte"
</script>

<svelte:head>
    <title>{$t('donate.title_page')}</title>
    <meta name="description" content="{$t('donate.description_page')}">
</svelte:head>

<Donate/>